var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgSmallSteps1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.62 265.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6abeec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.26,172c3.34,4.52,6.93,9,11.66,12,8.67,5.55,19.77,5.4,30,4a150.31,150.31,0,0,0,70.3-29.17c16.62-12.64,31.05-29,50.58-36.46,16.08-6.11,37.81-8.48,42.55-25,1.31-4.57.89-9.44.3-14.16-3.39-27-14-55.77-37.77-69-25.26-14.07-64.06-16.5-91.3-6.8-28.61,10.2-67.74,2-88,26.09C6.21,67.17,23.29,141,46.26,172Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.93,250.18c2.64,3.64,6.69,6,10.79,7.84a70,70,0,0,0,31.37,6c1,0,1.95-.1,2.93-.18A24.14,24.14,0,0,0,63,261.31c3.31-1.87,5.76-4.95,7.79-8.15C123,171-27.22,201.78,7.93,250.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSmallSteps1);
export default __webpack_public_path__ + "static/media/bg_small_steps_1.21e4712fb2778e5365197c4d07d03c39.svg";
export { ForwardRef as ReactComponent };